import { restorePublicShell } from "./lib/appShell";
import { createReloadGuard } from "./lib/reloadGuard";

const BOOTSTRAP_RETRY_STORAGE_KEY = "typelab_bootstrap_retry_once";
const BOOTSTRAP_RETRY_QUERY_KEY = "__tl_bootstrap_retry";
const bootstrapRetryGuard = createReloadGuard(BOOTSTRAP_RETRY_STORAGE_KEY, BOOTSTRAP_RETRY_QUERY_KEY);

const reloadForBootstrapFailure = () => {
  if (typeof window === "undefined") return;
  if (bootstrapRetryGuard.hasAttempted()) return;

  bootstrapRetryGuard.markAttempted();
  window.location.reload();
};

let bootstrapTriggered = false;
const triggerBootstrap = () => {
  if (bootstrapTriggered) return;
  bootstrapTriggered = true;
  void import("./bootstrapApp")
    .then((module) => {
      bootstrapRetryGuard.clearAttempted();
      module.bootstrapApp();
    })
    .catch((error) => {
      restorePublicShell();
      console.error("Failed to bootstrap app shell", error);
      reloadForBootstrapFailure();
    });
};

triggerBootstrap();
